import React from "react";
import Modal from "../../components/ui/Modal";
import FormMoreInfo from "../../components/FormMoreInfo/FormMoreInfo";

const ModalMoreInfoSL = ({ visible, onClose, onSubmit }) => {
  const handleSubmit = async (data) => {
    await onSubmit(data);
  };

  return (
    <Modal
      title="Encore une petite étape"
      visible={visible}
      onClose={onClose}
    >
      <FormMoreInfo onSubmit={handleSubmit} submitLabel="Lancer l'audit" />
    </Modal>
  );
};

export default ModalMoreInfoSL;
